import { RodFillerMaterial } from '@bechtel/types';

export interface FillerMaterialSelectorProps {
  fieldName: string;
  onSelect?: (fillerMaterial: RodFillerMaterial) => void;
}
